<gus-generic-dialog>
  <gus-dialog-body>
    <ng-container gusCustomDialogContent>
      @if (enableDisclaimer()) {
        <div class="gus-text-placeholder subscription-disclaimer gus-font-light gus-text-gray space-letter-047 line-height-24 fs16">
          With purchase of the Goomi Unlimited, you’ll get access to Les Mills & Zumba as a bonus
        </div>
      }

      <mat-radio-group [(ngModel)]="selectedPlatformSubscription">
        @for (platformSubscription of subscription.web; track $index) {
          <mat-radio-button class="collection-subscription-radio-button" [value]="platformSubscription">
            <div class="subscription-label">
              <div class="subscription-label__name fs16">{{ platformSubscription.name }}</div>

              <div class="subscription-label__details">
                <span class="space-letter-047 line-height-24 fs16">${{ platformSubscription.discounted_price || platformSubscription.price }}</span>
                <span class="flex flex-row gus-text-placeholder gus-font-light space-letter-047 line-height-24 fs16">
                  <span class="limit-date">
                    {{ platformSubscription.period | titlecase }}
                  </span>
                  <span>
                    You can cancel any time
                  </span>
                </span>
              </div>
            </div>
          </mat-radio-button>
        }
      </mat-radio-group>

      <span class="gus-text-placeholder payment-method-label gus-font-light gus-text-gray space-letter-047 line-height-24 fs16">Payment Method</span>

      <gus-card-payment-method></gus-card-payment-method>
    </ng-container>
  </gus-dialog-body>

  <gus-dialog-footer>
    <div class="subscription-dialog-footer" gusCustomDialogContent>
      <div class="gus-text-placeholder"></div>

      <div class="subscription-dialog-footer__actions">
        <wlcm-button type="paddingless" (clicked)="close()">
          <span class="text-transform-uppercase">Cancel</span>
          </wlcm-button>

        <wlcm-button class="design-button" (clicked)="submit()" [isDisabled]="!paymentMethodForm().isValid()" [isLoading]="loading$ | async">
          <span class="submit">Subscribe</span>
        </wlcm-button>
      </div>
    </div>
  </gus-dialog-footer>
</gus-generic-dialog>
